// extracted by mini-css-extract-plugin
module.exports = {"Title":"BuilderPanel_Title__1780b","Button":"BuilderPanel_Button__vCgz2","Header":"BuilderPanel_Header__27ClB"};